import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for the order detail page at `/orders/$orderId/`.
 */
export const Route = createFileRoute('/orders/$orderId')({
  staticData: { permission: 'orders.detail.view' },
  component: () => <Outlet />,
});
